import { useState, useEffect, useContext, useRef } from "react";
import { Button, Notification, Table } from "rsuite";
import axios from "../../utilities/axios";
import { UserContext } from "../../components/authProvider/main";
import { withRouter } from "react-router";
import { MethodsUtils } from "../../core/utils/MethodsUtils";

export type SystemData = {
    totalUsers: number,
    activeUsers: {
        user_id: string,
        user_name: string,
        user_email: string,
    }[]
};

type SystemPageState = {
    loading: boolean;
    stats: SystemData;
    lastRefresh: Date;
};

export const SystemPage = withRouter((props: any) => {
    const [stats, setStats] = useState<SystemPageState>({
        stats: {} as SystemData,
        loading: true,
        lastRefresh: new Date(),
    });
    const { data: user }: any = useContext(UserContext);
    const intervalRef = useRef<NodeJS.Timeout | null>(null);

    const loadSystemData = async () => {
        try {
            setStats((prev) => ({ ...prev, loading: true }));
            const { data } = await axios.get("/api/v1/system/data");

            setStats({
                stats: data?.item || {},
                loading: false,
                lastRefresh: new Date(),
            });
        } catch (error) {
            Notification.error({
                title: "Erro",
                message: "Não foi possível carregar os dados do sistema",
            });
        }
    };

    const handleRefresh = () => {
        loadSystemData();
    };

    const handleVisibilityChange = () => {
        if (document.visibilityState === 'visible') {
            loadSystemData();
        }
    };

    useEffect(() => {
        loadSystemData();

        intervalRef.current = setInterval(() => {
            if (document.visibilityState === 'visible') {
                loadSystemData();
            }
        }, 20000);

        document.addEventListener('visibilitychange', handleVisibilityChange);

        // document.getElementsByClassName('topbar')?.[0]?.remove()
        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);

    return (
        <div className="system" style={{ padding: 20, display: "flex", flexDirection: "column", gap: 20, width: '100%', overflow: 'auto' }}>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
                <div style={{ flex: 2 }}>
                    <h2>Gerenciamento do Sistema</h2>
                    <p>
                        Visualize estatísticas e gerencie usuários ativos
                        por empresa
                    </p>
                </div>
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'end', gap: 2 }}>
                    <h6>
                        {user?.user_name} | COXINHA DA HORA
                    </h6>
                    <Button
                        appearance="primary"
                        onClick={() => {
                            window.location.href = "/dashboard";
                        }}
                    >
                        <i className="fas fa-home mr-2"></i>
                        Dashboard
                    </Button>
                </div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: 10 }}>
                <div style={{ flex: 1, height: 150, minWidth: 300, padding: 20, border: '1px solid #aaa', display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: 10, borderRadius: 6, alignItems: 'center' }}>
                    <h5>
                        <i className="fas fa-user mr-4" style={{ lineHeight: 1.3 }}></i>
                        Usuários Ativos Agora
                    </h5>
                    <h3 >
                        {stats?.stats?.activeUsers?.length || 0}
                        &nbsp;/&nbsp;
                        {stats?.stats?.totalUsers || 0}
                    </h3>
                </div>
            </div>

            <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 32 }}>
                <div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'end', marginBottom: 8 }}>
                        <h4>Usuários Ativos Agora</h4>
                        <Button color="blue" onClick={handleRefresh} loading={stats.loading}>
                            <i className="fa fa-sync-alt mr-2"></i>
                            Atualizar
                        </Button>
                    </div>

                    <Table
                        autoHeight
                        data={stats?.stats?.activeUsers || []}
                        style={{ borderRadius: "8px" }}
                        bordered
                        cellBordered
                        hover
                        rowHeight={46}
                    >
                        <Table.Column width={60} align="center" fixed>
                            <Table.HeaderCell>
                                #
                            </Table.HeaderCell>
                            <Table.Cell>
                                {(_: any, rowIndex: number = 0) => <p>{rowIndex + 1}</p>}
                            </Table.Cell>
                        </Table.Column>

                        <Table.Column width={300}>
                            <Table.HeaderCell>
                                <i className="fas fa-user mr-4"></i>
                                Usuário
                            </Table.HeaderCell>
                            <Table.Cell
                                dataKey="user_name"
                            />
                        </Table.Column>

                        <Table.Column width={400}>
                            <Table.HeaderCell>
                                <i className="fas fa-credit-card mr-4"></i>
                                CPF/CNPJ
                            </Table.HeaderCell>
                            <Table.Cell>
                                {(rowData: any) => MethodsUtils.formatCpfCnpj(rowData?.user_cpf_cnpj || '')}
                            </Table.Cell>
                        </Table.Column>
                    </Table>
                </div>
            </div>
        </div>
    );
});
